(
    function (skyward, $)
    {
        function RelativeDate(unit, datePart, direction)
        {
            this.unit = unit;
            this.datePart = datePart;
            this.direction = direction;
            Object.freeze(this);
        }

        RelativeDate.prototype.toString = function()
        {
            if (isNaN(this.unit))
            {
                return "";
            }

            if (this.unit === 0)
            {
                return "Current Date";
            }

            if (this.unit === 250 && this.datePart === "Year")
            {
                if (this.direction === "From Now")
                {
                    return "Maximum Date";
                }

                return "Minimum Date";
            }

            var datePartDisplay = (this.unit === 1) ? this.datePart : this.datePart + 's';

            return this.unit + ' ' + datePartDisplay + ' ' + this.direction;
        };

        RelativeDate.parse = function (valueObj)
        {
            if (valueObj instanceof RelativeDate)
            {
                return valueObj;
            }
            if (valueObj === null || valueObj === undefined)
            {
                return null;
            }
            var value = valueObj.toString();

            if (value === "Maximum Date")
            {
                return new RelativeDate(250, "Year", "From Now");
            }
            else if (value === "Minimum Date")
            {
                return new RelativeDate(250, "Year", "Ago");
            }
            else if (value === "Current Date")
            {
                return new RelativeDate(0, "Day", "Ago");
            }
            else
            {
                var parts = /^(\d+) (Weekday|Day|Week|Month|Year)s? (Ago|From Now)$/i.exec(value);
                if (parts === null)
                {
                    return null;
                }
                return new RelativeDate(parseInt(parts[1]), parts[2], parts[3]);
            }
        };


        skyward.relativedatepicker = skyward.relativedatepicker || {};

        skyward.relativedatepicker.setValue = function (datePickerID, value)
        {
            var date = RelativeDate.parse(value);
            $("#" + datePickerID).val("");

            if (date === null)
            {
                skyward.relativedatepicker.showDatePicker();
                return;
            }

            skyward.relativedatepicker.showRelativeDateDisplay(datePickerID, date.toString());
            updateLaunchButtonData(datePickerID, date);
        };

        skyward.relativedatepicker.parseRelativeDateString = function (value)
        {
            return RelativeDate.parse(value);
        };

        var initRelativeDatePicker = function (selector)
        {
            $(selector + " .launchRelativeDatePickerUnbound").removeClass("launchRelativeDatePickerUnbound")
                .on("click", launchRelativeDatePicker)
                .on("keydown", launchRelativeDatePickerOnEnter);

            $(selector + " .relativeDateDisplayUnbound").removeClass("relativeDateDisplayUnbound").each(function () {
                var display = $(this);
                display.on("click", launchRelativeDatePicker);
                display.on("keydown", launchRelativeDatePickerOnEnter);

                var datepicker = display.siblings(".datepicker-wrapper").children(".datepicker");
                var label = datepicker.findLabel();
                if (label.length)
                {
                    display.attr("aria-labelledby", label.addIds().attr("id"));
                }
                if (datepicker.is("[readonly]"))
                {
                    display.siblings(".launchRelativeDatePicker").hide();
                }
            });

            function launchRelativeDatePickerOnEnter(e)
            {
                const key = skyward.keys.getKeyNamesFromEvent(e);
                if (key.ENTER || key.SPACE)
                {
                    launchRelativeDatePicker.call(this);
                }
            }
        };

        var launchRelativeDatePicker = function ()
        {
            var button = $(this);
            if (button.hasClass('readonly'))
            {
                return;
            }
            var datePickerId = button.data("relatedDatePicker");
            var builder = getRelativeDateBuilder(datePickerId);

            var buttonData = button.data();

            var unitBox = builder.find(".relativeDateUnit");
            const value = (buttonData.unit !== null && !isNaN(buttonData.unit)) ? buttonData.unit : "";
            skyward.controls.setValue(unitBox, value, true);
            unitBox.removeClass('masked');

            builder.find(".relativeDateDatePart > [selected], .relativeDateDirection > [selected]").removeAttr("selected"); //reset all selected values
            builder.find(".relativeDateDatePart > [value='" + (buttonData.datePart || "Day") + "']").attr("selected", "selected");
            builder.find(".relativeDateDirection > [value='" + (buttonData.direction || "Ago") + "']").attr("selected", "selected");

            var dialogOptions =
            {
                closeOnClick: true,
                closeOnEscape: true,
                closeOnGlassClick: true,
                anchorTo: skyward.global.mobileAccess ? null : button
            };

            var buttons = [
                {
                    text: "Save",
                    click: onSave,
                    icon: "Save"
                },
                {
                    text: "Cancel",
                    click: close,
                    icon: "Cancel"
                }
            ];

            var modal = skyward.modalLayer.showDialog("Select Relative Date", builder.children().clone(), buttons, dialogOptions);
            modal.content.data("relatedDatePicker", datePickerId);

            modal.content.find(".relativeDateUnit").focus();

            modal.content.find(".predefinedDateSelector").on("click", selectPreDefinedDate(modal));
        };

        var selectPreDefinedDate = function (modal)
        {
            return function () {
                var value = $(this).text().trim();
                var datePickerId = modal.content.data("relatedDatePicker");

                var date;

                if (value === "Maximum Date")
                {
                    date = new RelativeDate(250, "Year", "From Now");
                }
                else if (value === "Minimum Date")
                {
                    date = new RelativeDate(250, "Year", "Ago");
                }
                else
                {
                    date = new RelativeDate(0, "Day", "Ago");
                }

                skyward.relativedatepicker.showRelativeDateDisplay(datePickerId, date.toString());
                updateLaunchButtonData(datePickerId, date);
                modal.close();
            };
        };

        var onSave = function (e, modal)
        {
            var datePickerId = modal.content.data("relatedDatePicker");
            var unit = parseInt(modal.content.find(".relativeDateUnit").val());
            var datePart = modal.content.find(".relativeDateDatePart").val();
            var direction = modal.content.find(".relativeDateDirection").val();

            var result = new RelativeDate(unit, datePart, direction);
            $("#" + datePickerId).val("");
            skyward.relativedatepicker.showRelativeDateDisplay(datePickerId, result.toString());
            updateLaunchButtonData(datePickerId, result);

            modal.close();
        };

        var updateLaunchButtonData = function (datePickerId, value)
        {
            var buttonData = getRelativeDateLaunchButton(datePickerId).data();
            buttonData.unit = value.unit;
            buttonData.datePart = value.datePart;
            buttonData.direction = value.direction;

            var displayData = skyward.relativedatepicker.getRelativeDateDisplay(datePickerId).data();
            displayData.unit = value.unit;
            displayData.datePart = value.datePart;
            displayData.direction = value.direction;
        };

        skyward.relativedatepicker.showRelativeDateDisplay = function (datePickerId, value)
        {
            skyward.relativedatepicker.getRelativeDateDisplay(datePickerId).text(value).removeClass("hidden");

            var datepicker = $('#' + datePickerId);
            var datepickerData = datepicker.data();

            datepicker.addClass("relativeDate");
            datepickerData.relativeDate = value;
            datepicker.addClass("hidden");
            datepicker.trigger("dirty");
            datepicker.attr("data-relative-date", value);
            $('#' + datePickerId + "-errorLabel").addClass("hidden").empty();
        };

        skyward.relativedatepicker.showDatePicker = function (datePickerId)
        {
            var relativeDateDisplay = skyward.relativedatepicker.getRelativeDateDisplay(datePickerId);

            if (!relativeDateDisplay.length)
            {
                return $();
            }

            var datepicker = $('#' + datePickerId);
            var datepickerData = datepicker.data();
            relativeDateDisplay.addClass("hidden");
            datepicker.removeClass("relativeDate");
            datepicker.removeClass("hidden");
            datepickerData.relativeDate = null;
            $('#' + datePickerId + "-errorLabel").removeClass("hidden");
            return datepicker;
        };

        var close = function (e, modal)
        {
            modal.close();
        };

        skyward.relativedatepicker.getRelativeDateDisplay = function (datePickerId)
        {
            return $('#' + datePickerId + "-relativeDateDisplay");
        };

        var getRelativeDateBuilder = function (datePickerId)
        {
            return $('#' + datePickerId + "-relativeDateBuilder");
        };

        var getRelativeDateLaunchButton = function (datePickerId)
        {
            return $('#' + datePickerId + "-relativeDateBuilderLaunchButton");
        };

        skyward.window.registerLoadDOMCallback(initRelativeDatePicker);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
